import API from "../../../utils/helpers/API.helpers";

const IzinMajuSidangService = {
  async getIzinMajuSidangPembimbing(mKSpesialId) {
    return await API.get({
      endpoint: `/mahasiswa/get-persetujuan-sidang?mk_spesial=${mKSpesialId}`,
    });
  },
  async getIzinMajuSidang(mKSpesialId) {
    return await API.get({
      endpoint: `/approval-sidang/?mk_spesial=${mKSpesialId}`,
    });
  },
  async putIzinMajuSidang(mKSpesialId) {
    return await API.put({ endpoint: `/approval-sidang/${mKSpesialId}/` });
  },
};

export default IzinMajuSidangService;
